/* global Waypoint anime */

// Flag to prevent diagram animation from repeating
let diagramAnimated = false;
document.querySelectorAll('.q-diagram-content').forEach(function(diagramcontent) {
    const diagram = document.querySelector('.vmdr-cycle-diagram');
    // Flag to prevent individual content animation from triggering more than once
    let contentHasAnimated = false;
    new Waypoint({
        element: diagramcontent,
        handler: function() {
            if (contentHasAnimated) return;  // Skip if this content block has already animated
            contentHasAnimated = true; // This content block as animated
            // If the diagram hasn't been animated yet, animate it
            if (!diagramAnimated) {
                // Animate the diagram 
                anime({
                    targets: diagram,
                    scale:[0.4, 1],
                    duration:1000,
                    easing: 'easeInOutQuad',
                    complete: function() {
                        // After the diagram scaling completes, trigger text fade-in after 2 seconds
                        setTimeout(function() {
                            // Animate each text element ('.q-diagram-content') one by one after 2 seconds
                            document.querySelectorAll('.q-diagram-content').forEach(function(content, idx) {
                                // Each content block will appear with a delay based on its index
                                anime({
                                    targets: content,
                                    opacity: 1,
                                    duration: 1000,
                                    easing: 'easeInOutQuad',
                                    delay: idx * 500,  // Staggered delay, 500ms per index
                                });
                            });
                        }, 800); // 2 seconds delay after diagram scale-up
                    }
                });
                diagramAnimated = true;  // Mark the vmdr diagram as have been animated
            }
            this.destroy(); // Destroy the waypoint
        },
        offset: '95%', 
        once: true      // Ensure the waypoint only fires once
    });
});
